import React from 'react';
import { FormattedMessage } from 'react-intl';

import PublicShell from '../../components/PublicShell';
import useLanguageContext from '../../hooks/useLanguageContext';
import { LegalDoc, getLegalContent } from './content';
import {
  StyledLegalEyebrow,
  StyledLegalHeading,
  StyledLegalIntro,
  StyledLegalParagraph,
  StyledLegalSection,
  StyledLegalTitle,
  StyledLegalUpdated,
} from './styles';

interface LegalPageProps {
  doc: LegalDoc;
}

const LegalPage: React.FC<LegalPageProps> = ({ doc }) => {
  const { language } = useLanguageContext();
  const content = getLegalContent(doc, language);

  return (
    <PublicShell seoTitle={content.title}>
      <StyledLegalEyebrow>
        <FormattedMessage id='public.legal' defaultMessage='Legal' />
      </StyledLegalEyebrow>
      <StyledLegalTitle>{content.title}</StyledLegalTitle>
      <StyledLegalUpdated>{content.updated}</StyledLegalUpdated>
      <StyledLegalIntro>{content.intro}</StyledLegalIntro>

      {content.sections.map((section) => (
        <StyledLegalSection key={section.heading}>
          <StyledLegalHeading>{section.heading}</StyledLegalHeading>
          {section.body.map((paragraph, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <StyledLegalParagraph key={index}>{paragraph}</StyledLegalParagraph>
          ))}
        </StyledLegalSection>
      ))}
    </PublicShell>
  );
};

export default LegalPage;
